import ConnectAppTemplate from './ConnectAppTemplate'

export default ConnectAppTemplate
